// extracted by mini-css-extract-plugin
export default {"appIconBtn":"AppIconBtn_appIconBtn__75S+2","smallBtn":"AppIconBtn_smallBtn__jHcmg"};